export default {
  'home': 'Home Page',
  'my_accout': 'My Account',
  'account_info': 'Account Information',
  'bonds': 'Debt Application',
  'otherAccount': 'Trading Account Application',
  'records': 'Funds Record',
  'setting': 'Setting',
  'deposit': 'Deposit',
  'subAccount': 'Sub-Account Application',
  'tradeProduct': 'Structured Products Application',
  'withdrawal': 'Withdraw',
  'internal_transfer': 'Internal Transfer',
  'download': 'Platform Download',
  'trade_recordes': 'Trading Record',
  'open_trades': 'Open Trades',
  'close_trades': 'Close Trades',
  'logout': 'Logout',
  'table-download': 'File Download',
  'exchange': 'Foreign Exchange',
  'quotes': 'Real Time Quote Application'
}
